import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";

interface DisputeRejectedAlertProps {
  resolution: string;
  simplifiedBanEnabled: boolean;
}

export function DisputeRejectedAlert(props: DisputeRejectedAlertProps) {
  const { resolution, simplifiedBanEnabled } = props;

  const {
    placementInterviewAttendancePolicySupportLink,
    placementInterviewAttendanceSimplifiedPolicySupportLink,
  } = useSupportLinks();

  const supportLink = simplifiedBanEnabled
    ? placementInterviewAttendanceSimplifiedPolicySupportLink
    : placementInterviewAttendancePolicySupportLink;

  return (
    <Stack spacing={2}>
      <Text variant="body2" textAlign="center">
        <Box component="span" sx={{ fontWeight: 700 }}>
          Reason of rejection:
        </Box>{" "}
        {resolution}
      </Text>
      <Text variant="body2" textAlign="center">
        Click{" "}
        <a href={supportLink} target="_blank" rel="noopener noreferrer">
          here
        </a>{" "}
        to review the interview attendance policy.
      </Text>
    </Stack>
  );
}
